import script from "./form-accessory.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-accessory.vue?vue&type=script&setup=true&lang=ts"

import "./form-accessory.vue?vue&type=style&index=0&id=41e87e8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41e87e8a"]])

export default __exports__